// Copyright © 2021 Move Closer

export enum BackgroundColorPalette {
  CTA = '#398154',
  DarkGray = '#EDEDED',
  LightGray = '#F7F7F7',
  White = '#fff',
  None = ''
}
